'use client';
import React from 'react';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';

const Header = (props) => {
  const t = useTranslations('');
  const router = useRouter();
  const { websiteCode } = props;
  const menuTree = props?.menuTree ?? [];

  return (
    <div className="text-gray-600 text-sm md:text-base w-full max-sm:w-1/3 hidden-mobile">
      <div className="h-full flex items-center justify-between bg-[#EFEEEE] px-1">
        <div className="text-gray-600 text-sm md:text-base w-2/3 ">
          <ul>
            <li>
              {menuTree
                .filter((item) => ['hoi-dap', 'lien-he', 'so-do-cong'].includes(item?.slug))
                .map((data) => (
                  <a key={data?.id} href={`/${data.slug}`} className="text-xs pr-7 font-[400] text-[#212020CC]">
                    {data?.name}
                  </a>
                ))}
            </li>
          </ul>
        </div>
        <div className="text-gray-600 text-sm md:text-base w-1/3 justify-end flex items-center gap-2">
          <div className={`flex justify-end relative mr-1 py-1`}>
            <input
              id="search-input"
              type="text"
              placeholder={t('home.searchArticle')}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  router.push(`/tim-kiem-tin-tuc?text=${e.target.value}`);
                }
              }}
              className={`w-full p-2 pr-10 border border-gray-300 rounded bg-white text-gray-700 h-[25px] text-[13px] focus:outline-none focus:border-[#D2401A] focus:ring-1 focus:ring-[#D2401A]`}
            />
            <button
              onClick={() => {
                const input = document.getElementById('search-input');
                if (input) {
                  router.push(`/${websiteCode ? `sub/${websiteCode}/` : ''}tim-kiem-tin-tuc?text=${input.value}`);
                }
              }}
              aria-label="Tìm kiếm"
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-[#D2401A] transition-colors duration-200">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M14.2125 13.3516L10.1547 9.29375C10.7844 8.47969 11.125 7.48438 11.125 6.4375C11.125 5.18438 10.6359 4.00937 9.75156 3.12344C8.86719 2.2375 7.68906 1.75 6.4375 1.75C5.18594 1.75 4.00781 2.23906 3.12344 3.12344C2.2375 4.00781 1.75 5.18438 1.75 6.4375C1.75 7.68906 2.23906 8.86719 3.12344 9.75156C4.00781 10.6375 5.18438 11.125 6.4375 11.125C7.48438 11.125 8.47813 10.7844 9.29219 10.1562L13.35 14.2125C13.3619 14.2244 13.376 14.2338 13.3916 14.2403C13.4071 14.2467 13.4238 14.2501 13.4406 14.2501C13.4575 14.2501 13.4741 14.2467 13.4897 14.2403C13.5052 14.2338 13.5194 14.2244 13.5312 14.2125L14.2125 13.5328C14.2244 13.5209 14.2338 13.5068 14.2403 13.4912C14.2467 13.4757 14.2501 13.459 14.2501 13.4422C14.2501 13.4254 14.2467 13.4087 14.2403 13.3931C14.2338 13.3776 14.2244 13.3635 14.2125 13.3516ZM8.9125 8.9125C8.25 9.57344 7.37187 9.9375 6.4375 9.9375C5.50312 9.9375 4.625 9.57344 3.9625 8.9125C3.30156 8.25 2.9375 7.37187 2.9375 6.4375C2.9375 5.50312 3.30156 4.62344 3.9625 3.9625C4.625 3.30156 5.50312 2.9375 6.4375 2.9375C7.37187 2.9375 8.25156 3.3 8.9125 3.9625C9.57344 4.625 9.9375 5.50312 9.9375 6.4375C9.9375 7.37187 9.57344 8.25156 8.9125 8.9125Z"
                  fill="currentColor"
                  fillOpacity="0.88"
                />
              </svg>
            </button>
          </div>
          {/* <LanguageSwitcher /> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
